export default "__VITE_ASSET__CnwWWlRR__"